module.exports = __webpack_public_path__ + "img/slide15.f5f89ce7.png";